<template>
  <div class="tw_from_to">
    <div class="tw_from_to_row">
      <div class="from_block" :class="{'editSide': editableSide === 'from' && processProgressStatus !== PROCESS_PROGRESS_STATUS.DONE && processProgressStatus !== PROCESS_PROGRESS_STATUS.AGREED}">
        <div class="from_to_header">
          <div v-if="editableSide === 'from' && processProgressStatus !== PROCESS_PROGRESS_STATUS.DONE && processProgressStatus !== PROCESS_PROGRESS_STATUS.AGREED" class="editable_label">編集可
            <i class="el-icon-edit" />
          </div>
          <span class="cell th">from</span>
        </div>
        <div class="cell td">
          <span class="tw_from_to_text">{{from.fromCompanyShortName}}</span>
        </div>
        <div class="cell td">
          <span class="tw_from_to_text">{{from.fromSectionShortName}}</span>
        </div>
      </div>
      <div class="to_block" :class="{'editSide': editableSide === 'to' && processProgressStatus !== PROCESS_PROGRESS_STATUS.DONE && processProgressStatus !== PROCESS_PROGRESS_STATUS.AGREED}">
        <div class="from_to_header">
          <div v-if="editableSide === 'to' && processProgressStatus !== PROCESS_PROGRESS_STATUS.DONE && processProgressStatus !== PROCESS_PROGRESS_STATUS.AGREED" class="editable_label">編集可
            <i class="el-icon-edit" />
          </div>
          <span class="cell th">to</span>
        </div>
        <div class="cell td">
          <span class="tw_from_to_text">{{to.toCompanyShortName}}</span>
        </div>
        <div class="cell td">
          <span class="tw_from_to_text">{{to.toSectionShortName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {PROCESS_PROGRESS_STATUS} from 'lib-tw-common';

export default {
  name: 'TwFromTo',
  props: {
    from: Object,
    to: Object,
    editableSide: String,
    processProgressStatus: Number
  },
  data() {
    return {
      PROCESS_PROGRESS_STATUS
    };
  },
  computed: {

  },
};
</script>

<style lang="scss">
  .tw_from_to {
    display: inline-block;
  }
  .tw_from_to_row {
    display: flex;
    align-items: flex-start;
  }
  .from_block,
  .to_block {
    display: inline-block;
    vertical-align: top;
    position: relative;
    max-width: 225px;

    .cell {
      display: block;
      font-size: 12px;
      line-height: 15px;
      color: #111;
      white-space: normal;
      word-break: break-word;

      &.th {
        font-weight: 500;
        font-size: 10px;
        line-height: 11px;
        color: $color_black;
        text-align: center;
      }
      &.td {
        margin-top: 8px;
      }
    }
    &.editSide {
      border: 1px solid $color_primary_blue;
    }
  }
  .from_block {
    margin-right: 40px;
  }
  .editable_label {
    display: flex;
    align-items: center;
    color: $color_primary_blue;
    font-size: 10px;
    font-weight: bold;

    i {
      font-size: 12px;
    }
  }
  .from_to_header {
    display: flex;
    align-items: baseline;
    justify-content: center;
    position: relative;
  }
</style>
